/* tslint:disable: no-switch-case-fall-through */
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommunicationService } from 'src/app/shared/services/communication/communication.service';
import { Company } from 'src/app/shared/interfaces/company';
import { Subscription } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SessionStorageService } from 'src/app/shared/services/session-storage/session-storage.service';
import { FolderSettingsComponent } from 'src/app/navigation/folder-settings/folder-settings.component';
import { Modalconfig, ScrollbarOptions, serverUrl } from 'src/app/shared/constants';
import { find, cloneDeep, isNil } from 'lodash';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { Category } from '../shared/models/category.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { VpcCommsService } from 'src/app/shared/services/vpc-comms/vpc-comms.service';
import { profileRoles } from 'src/app/shared/interfaces/sessionStorageModel';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Collection } from 'src/app/shared/model/collections.models';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.scss'],
    animations: [
        trigger('slideIn', [
            state('in', style({
                width: '90px'
            })),
            state('out', style({
                display: 'none',
                width: '230px',
            })),
            transition('out => in', animate('2s ease-in-out'))
        ]),
        trigger('slideOut', [
            state('in', style({
                display: 'none',
                width: '90px'
            })),
            state('out', style({
                width: '230px'
            })),
            transition('in => out', animate('2s ease-in-out')),
        ])
    ],
    standalone: false
})
export class SideBarComponent implements OnInit, OnDestroy {

  scrollbarOptions = ScrollbarOptions;
  selectedParentModule: string;
  showSidebar = 'generic';
  activeModule: string;
  companyId: number;
  subscription: Subscription;
  loggedInUserRole: string;
  company: Company;
  modalRef: BsModalRef;
  modalSubscription: Subscription;
  enableView = false;
  receivedCgs: Category[] = [];
  activeCategory: string;
  categoryFilter: string;
  showAddFolder = true;
  vPlaybookManagerId: number;
  showManagerNav = false;
  showRepNav = false;
  viewingAsManagerId: number;
  serverUrl = serverUrl;
  winAppUrl: string;
  macAppUrl: string;
  iosAppUrl: string;
  os: string;
  showForPlaybooks = true;
  hasReps = false;
  userId: number;
  fetchCategoriesSub: Subscription;
  showDownloadSub: Subscription;
  showDownloadButton = false;
  vpcDevices: boolean;
  isMobileView: boolean;
  helpMenu: string;
  isCollapsibleMenu: boolean;
  isDisplayDownloadMenu = false;
  downloadOsUrl: string;
  downoadOsTitle: string;
  showLMSManagerNav = false;
  showLMSUserNav = false;
  showPendingScoreNotification = false;
  pendingScoreSub: Subscription;
  userHasLmsAccess = false;
  lcFeedbackInfo = null;
  feedbackChangeSub: Subscription;
  userEnvironment = environment;
  showPlaybookBranding = true;
  playbookBrandingSub: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private communicationService: CommunicationService,
    private sessionStorageService: SessionStorageService,
    public modalService: BsModalService,
    private commonHttpService: CommonHttpService,
    private deviceService: DeviceDetectorService,
    private vpcService: VpcCommsService
  ) {
    this.helpMenu = this.isMenuCollapsed ? 'in' : 'out';
    this.deviceService.setDeviceInfo(window.navigator.userAgent);
    this.os = this.deviceService.os();
    this.winAppUrl = this.serverUrl + '/resources/app/pc/vplaybook_setup.exe';
    this.macAppUrl = this.serverUrl + '/resources/app/mac/vplaybook.dmg';
    this.iosAppUrl = 'http://appstore.com/vplaybook';
    this.vpcDevices = !this.vpcService.CheckNodeWebkit()
      && !this.deviceService.isMobile()
      && !this.vpcService.isIOS()
      && !this.vpcService.isIPad();
  }

  checkForDownloadBtn() {
    return this.showDownloadButton && this.activeModule === 'playbooks' && this.vpcDevices;
  }

  ngOnInit() {
    this.getCompany();
    this.getUserClaims();
    this.filterDropdownCategory();
    this.viewingAsManagerId = Number(this.route.snapshot.queryParams.mid);
    // To open challenge nav as per selection
    if (this.getUserRoleIndex === 2 && !this.viewingAsManagerId) {
      this.showManagerNav = ['coachingdashboard', 'challenges', 'teamassessment', 'coachingleaderboard',
        'featuredcontent', 'challengefeedback', 'challengestemplate'].includes(this.activeModule);

      this.showRepNav = ['repcoachingdashboard', 'repchallenges', 'repleaderboard',
        'repfeaturedcontent', 'repfeedback'].includes(this.activeModule);
    }

    this.showLMSManagerNav = ['managerlmsfeedback', 'managerlmsleaderboard', 'managerlmsparticipantbreakdown'].includes(this.activeModule);

    this.showLMSUserNav = ['userlmsdashboard', 'userlmsfeedback', 'userlmsleaderboard'].includes(this.activeModule);

    this.fetchCategoriesSub = this.communicationService.fetchSideBarCategories().subscribe(status => {
      if (status) {
        this.getPlaybookCategories(this.categoryFilter);

      }
    });
    this.pendingScoreSub = this.communicationService.fetchPendingScoreNotification().subscribe(status => {
      this.showPendingScoreNotification = status;
    });
    this.feedbackChangeSub = this.communicationService.getSideBarFeedbackChange().subscribe(status => {
      this.checkFeedBackCount();
    });
    this.getShowDownloadOption();
    this.getPlaybookBranding();
    this.isMobileView = window.innerWidth <= 767 ? true : false;
  }

  getShowDownloadOption() {
    this.showDownloadSub = this.communicationService.getShowDowloadOption().subscribe(status => {
      this.showDownloadButton = status;
      if (status) {
        if (this.showDownloadButton && this.activeModule === 'playbooks' && this.vpcDevices) {
          this.isDisplayDownloadMenu = true;
          let appDetails: any;
          appDetails = this.getAppDetails();
          this.downoadOsTitle = appDetails.title;
          this.downloadOsUrl = appDetails.url;
        }
      }
    });
  }

  getPlaybookBranding() {
    this.playbookBrandingSub = this.communicationService.getCompany().subscribe(company => {
      if (company) {
        this.showPlaybookBranding = company.isBrandingActive;
      }
    });
  }
  getAppDetails() {
    switch (this.os) {
      case 'Windows':
        return {
          title: 'Download Win App',
          url: this.winAppUrl
        };
      case 'Mac':
        return {
          title: 'Download Mac App',
          url: this.macAppUrl
        };
      default:
        return {
          title: 'Download IOS App',
          url: this.iosAppUrl
        };
    }
  }

  @Input() set isMenuCollapsed(isMenuCollapsed: boolean) {
    this.isCollapsibleMenu = isMenuCollapsed;
    this.helpMenu = isMenuCollapsed ? 'in' : 'out';
  }
  // Get the input value of the selected module from the app.component.ts.
  // According to that we will select that module.
  @Input()
  public set selectedModule(selectedModule: string) {
    // to set category filter in case user redirected directly to filtered category url
    if (this.router.url.indexOf('playbooks/category') !== -1) {
      this.categoryFilter = this.router.url.split('/').pop();
    } else {
      this.activeModule = selectedModule.toLowerCase();
    }
    if (this.activeModule === 'playbooks' && this.receivedCgs.length === 0 && this.companyId) {
      this.getPlaybookCategories(null);
    }
    this.setSelectedModule(selectedModule);
    this.viewingAsManagerId = Number(this.route.snapshot.queryParams.mid);
    this.setSidebar();
  }

  get getShowForPlaybooks() {
    if (this.activeModule === 'profile' && this.loggedInUserRole) {
      if ([profileRoles.administrator.toString(), profileRoles.playbookOwner.toString(), profileRoles.salesManager.toString(),
      profileRoles.user.toString()].indexOf(this.loggedInUserRole) !== -1) {
        this.showForPlaybooks = true;
      } else {
        this.showForPlaybooks = false;
      }
    } else {
      this.showForPlaybooks = true;
    }
    return this.showForPlaybooks;
  }

  /**
   * Get user access level
   *
   * Return value:
   * Admin -> 0
   * Manager -> 1
   * Manager & Rep -> 2
   * Reps -> 3
   * NOTA -> 4
   */
  get getUserRoleIndex() {
    switch (this.loggedInUserRole) {
      case 'SuperVPlaybookAdmin':
      case 'StandardVPlaybookAdmin':
      case 'Administrator':
        return 0;

      case 'SalesManager':
        return this.vPlaybookManagerId
          ? this.hasReps
            ? 2
            : 3
          : 1;

      case 'User':
        return 3;

      default:
        return 4;
    }
  }

  // For setting the sidebar as per selected module
  setSidebar() {
    switch (this.selectedParentModule) {
      case 'settings':
        this.showSidebar = 'settings';
        break;

      case 'admins':
      case 'adminReport':
        this.showSidebar = 'admins';
        break;

      case 'pagetemplates':
      case 'templates':
      case 'reportdescriptiontemplate':
      case 'coachingchallenges':
      case 'playbooktemplatecompanies':
      case 'adminteamassessment':
      case 'learningcenter':
      case 'collectiontemplateeditor':
        this.showSidebar = 'templates';
        break;

      default:
        this.showSidebar = 'generic';
        break;
    }
  }

  // Set Parent selectedmodule.
  // Set the selected module to show active symbol.
  setSelectedModule(selectedModule: string) {
    this.selectedParentModule = null;
    switch (selectedModule.toLowerCase()) {
      // People Menu
      case 'people':
      case 'roles':
      case 'help':
      case 'tags':
      case 'customfields':
      case 'bulkaction':
      case 'notification':
      case 'hierarchymap': 
      case 'permissionsgroups':
        this.selectedParentModule = 'people';
        break;

      // Settings Menu
      case 'userguide':
      case 'releasenotifications':
      case 'applicationversion':
        this.selectedParentModule = 'settings';
        break;

      // Reports Menu
      case 'report':
      case 'reportinsightsdashboard':
      case 'scheduledreport':
      case 'reportdescription':
        this.selectedParentModule = 'reports';
        break;

      // Templates Menu
      case 'pagetemplates':
      case 'reportdescriptiontemplate':
      case 'coachingchallenges':
      case 'adminteamassessment':
      case 'badges':
      case 'templates':
      case 'playbooktemplatecompanies':
      case 'learningcenter':
      case 'collectiontemplateeditor':
        this.selectedParentModule = 'templates';
        break;

      // Company Template Menu
      case 'companyconvtemplates':
      case 'conversationtemplate':
      case 'companypagetemplates':
      case 'companyplaybooktemplates':
        this.selectedParentModule = 'companytemplates';
        break;

      // Playbooks Menu
      case 'playbooks':
        this.selectedParentModule = 'playbooks';
        break;

      // Admins Menu
      case 'admins':
      case 'aboutuserlevels':
      case 'searchall':
        this.selectedParentModule = 'admins';
        break;

      // Admins Reports Menu
      case 'adminreports':
      case 'scheduleadminreports':
        this.selectedParentModule = 'adminReport';
        break;

      // Coaching Menu Admin
      case 'adminchallenges':
      case 'adminleaderboard':
      case 'adminfeaturedcontent':
      case 'challengeresponses':
      case 'admindashboard':
      case 'challengetemplate':

      // Coaching Menu Manager
      case 'coachingdashboard':
      case 'challenges':
      case 'teamassessment':
      case 'coachingleaderboard':
      case 'featuredcontent':
      case 'challengefeedback':
      case 'challengestemplate':

      // Coaching Menu Rep
      case 'repcoachingdashboard':
      case 'repchallenges':
      case 'repleaderboard':
      case 'repfeaturedcontent':
      case 'repfeedback':
        this.selectedParentModule = 'coaching';
        break;

      case 'vbuilder':
        this.selectedParentModule = 'vbuilder';
        break;

      // LMS Menu Admin
      case 'adminlmsdashboard':
      case 'adminlmscollectiontemplates':
      case 'adminlmsfeedback':
      case 'adminlmsscorm':
      case 'adminlmsleaderboard':
      case 'adminlmsedittemplate':
      case 'adminlmsviewtemplate':
      case 'adminlmsparticipantbreakdown':
      case 'admincollectionresponses':
      case 'adminlmscollectiontemplateeditor':

      // LMS Menu Manager
      case 'managerlmsdashboard':
      case 'managerlmsfeedback':
      case 'managerlmsleaderboard':
      case 'manageruserlmsleaderboard':
      case 'managerlmsedittemplate':
      case 'managerlmsviewtemplate':
      case 'managerlmsparticipantbreakdown':
      case 'managercollectionresponses':
      case 'managerlmscollectiontemplates':
      case 'managerlmscollectiontemplateeditor':

      // LMS Menu User
      case 'userlmsdashboard':
      case 'userlmsfeedback':
      case 'userlmsleaderboard':
      case 'userlmsviewtemplate': {
        this.selectedParentModule = 'lc';
        this.checkFeedBackCount();
      }
    }
  }

  // Get companyId and Company information to show the path of the routes.
  getCompany() {
    this.subscription = this.communicationService.getCompany().subscribe(company => {
      if (company) {
        this.companyId = company.id;
        this.company = company;
        if (this.activeModule === 'playbooks' || this.categoryFilter) {
          this.getPlaybookCategories(this.categoryFilter);
        }

        if (company.enableLearningCenterAccess) {
          this.communicationService.setShowHideLoader({ loaderId: 'simpleLoader', text: '', isShow: true });
          this.checkFeedBackCount(true);
          if (this.loggedInUserRole === profileRoles.salesManager || this.loggedInUserRole === profileRoles.user) {
            this.checkUserLmsView();
          } else {
            this.userHasLmsAccess = true;
          }
        }

        if (this.loggedInUserRole === profileRoles.salesManager && (company.hasCoachingAccess || company.enableLearningCenterAccess)) {
          this.commonHttpService.get({
            uri: `/api/Challenge/GetAllReps?managerId=${this.userId}&companyId=${this.companyId}`
          }).subscribe((repsArray: any[]) => {
            this.hasReps = repsArray.length > 0;
          });
        }
      }
    });
  }

  checkUserLmsView() {
    this.commonHttpService.get({
      uri: `/api/Collections/GetCollectionsByRepsId?repId=${this.userId}&companyId=${this.companyId}`
    }).subscribe((collections: Collection[]) => {
      this.userHasLmsAccess = collections.length > 0;
    });
  }

  checkFeedBackCount(hideLoader = false) {
    if (!isNil(this.companyId) && [profileRoles.superVPlaybookAdmin.toString(), profileRoles.standardVPlaybookAdmin.toString(), profileRoles.administrator.toString(), profileRoles.salesManager.toString(), profileRoles.user.toString()].includes(this.loggedInUserRole))
      this.commonHttpService.get({
        uri: `/api/CollectionFeedback/ShowCollectionFeedbackSideMenuOption?companyId=${this.companyId}`
      }).subscribe((resp: any) => {
        this.lcFeedbackInfo = resp;
        if (hideLoader)
          this.communicationService.setShowHideLoader({ loaderId: 'simpleLoader', text: '', isShow: false });
      });
  }

  // Check if top menu item can be showed by a user role.
  showNavigationItem(roles: string[]) {
    return find(roles, (role) => {
      return role.toLowerCase() === this.loggedInUserRole.toLowerCase();
    }) ? true : false;
  }

  getUserClaims() {
    const profileData = this.sessionStorageService.getLoggedInProfileDetail();
    if (profileData) {
      this.loggedInUserRole = profileData.role;
      this.vPlaybookManagerId = profileData.vPlaybookManagerId;
      this.userId = profileData.id;
      if (!this.companyId) {
        const company = this.sessionStorageService.getCompanyData();
        if (company) {
          this.company = company;
          this.companyId = this.company.id;
        }
      }
    }
  }

  // Check if company has vBuilder Access
  checkCompanyHasVBuilderAccess(): boolean {
    return (this.company && this.company.hasVBuilderAccess
      && this.showNavigationItem(['Administrator', 'PlaybookOwner']))
      ? true : false;
  }

  // Check if company has the report access.
  checkCompanyHasReportAccess() {
    switch (this.loggedInUserRole.toLowerCase()) {
      case 'SuperVPlaybookAdmin'.toLowerCase():
      case 'StandardVPlaybookAdmin'.toLowerCase():
        return true;
      case 'Administrator'.toLowerCase():
        return (this.company && this.company.enableReporting) ? true : false;
      case 'SalesManager'.toLowerCase():
        return (this.company && this.company.enableReporting && this.company.allowManagerRepHierarchy) ? true : false;
      default:
        break;
    }
  }

  /**
   * Open folder CRUD modal
   */
  openFolderModal() {
    const initialState = {
      categoriesOriginal: cloneDeep(this.receivedCgs),
      companyId: this.companyId
    };

    this.modalRef = this.modalService.show(FolderSettingsComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));

    this.modalSubscription = this.modalService.onHide.subscribe(() => {
      if (this.modalRef) {
        const categories = this.modalRef.content.categories.sort((a, b) => a.ordinal - b.ordinal);
        this.receivedCgs = cloneDeep(categories);
      }
      this.modalSubscription.unsubscribe();
    });
  }

  /**
   * Get playbook categories
   */
  getPlaybookCategories(categoryFilter) {
    this.commonHttpService.get({
      uri: `/api/Categories/GetAllCategories?companyId=${this.companyId}&includeAll=${false}`,
      message: {
        showMessage: false
      }
    }).subscribe((response: Category[]) => {
      this.receivedCgs = response.filter(c => !c.isDeleted).sort((a, b) => a.ordinal - b.ordinal);
      let allCategory = this.receivedCgs;
      // to set active category if user redirected directly to filtered category url
      if (categoryFilter && this.receivedCgs.length) {
        this.receivedCgs.forEach((category: Category) => {
          if (category.id === +categoryFilter) {
            this.activeCategory = category.name;
            this.communicationService.sendCategoryFilter(category.id, category, allCategory);
          }
        });
      }
    });
  }

  filterDropdownCategory() {
    this.communicationService.getCategoryDropdown().subscribe((category) => {
      if (category.categoryName) {
        this.activeCategory = category.categoryName;
        if (this.activeCategory === 'All Playbooks') {
          this.activeModule = 'playbooks';
          this.showAddFolder = true;
        } else {
          this.activeModule = '';
        }
      }
      if (category.categoryId) {
        this.categoryFilter = category.categoryId;
      }
    });
  }

  /**
   * To filter playbook list based on selected category
   */
  filterPlaybooks(category: Category) {
    this.activeCategory = category.name;
    this.activeModule = '';
    let allCategory = cloneDeep(this.receivedCgs);
    this.communicationService.sendCategoryFilter(category.id, category, allCategory);
  }

  /**
   * To remove category filter
   */
  removeCategoryFilter() {
    this.activeCategory = '';
    this.showAddFolder = true;
    this.activeModule = 'playbooks';
    this.communicationService.removeCategoryFilter();
    const path = window.location.pathname;
    if (path.indexOf('/playbooks') === -1 || path.indexOf('/category') !== -1) {
      this.router.navigateByUrl(this.playbookPageUrl());
    }
  }

  // returns playbook page url according to current user
  playbookPageUrl(): string {
    return ([profileRoles.administrator.toString(), profileRoles.playbookOwner.toString(), profileRoles.salesManager.toString(),
    profileRoles.user.toString()].indexOf(this.loggedInUserRole) === -1)
      ? `/company/${this.companyId}/playbooks` : `/playbooks`;
  }

  /**
   * Get router link as per role and module
   *
   * @param routingModule Name of module to switch
   */
  getCoachingRouterLink(routingModule: string): string {
    if (this.getUserRoleIndex === 4) {
      return;
    }
    const verb = ['admin', 'manager', 'manager', 'rep'][this.getUserRoleIndex];

    const routesObject = {
      admin: {
        dashboard: 'challenges/dashboard',
        challenges: 'challenges',
        leaderboard: 'challenges/leaderboard',
        featuredcontent: 'featuredcontent',
        challengeresponses: 'challengeresponses',
        challengestemplate: 'challengetemplate',
      },
      manager: {
        dashboard: 'coachingdashboard',
        challenges: 'challenges',
        teamassessment: 'teamassessment',
        leaderboard: 'leaderboard',
        featuredcontent: 'featuredcontent',
        feedback: 'challengefeedback',
        challengeresponses: 'challengeresponses',
        challengestemplate: 'challengestemplate',
      },
      rep: {
        dashboard: 'coachingdashboardrep',
        challenges: 'challenges',
        leaderboard: 'leaderboard',
        featuredcontent: 'featuredcontent',
        feedback: 'challengefeedback'
      }
    };

    return `company/${this.companyId}/${verb}/${routesObject[verb][routingModule]}`;
  }

  /**
  * Get router link as per role and module
  *
  * @param routingModule Name of module to switch
  */
  getLmsRouterLink(routingModule: string, asUser = false): string {
    if (this.getUserRoleIndex === 4) {
      return;
    }
    let internalRoleIndex = this.getUserRoleIndex;

    if (asUser) {
      internalRoleIndex = 3;
    }

    const verb = ['admin', 'manager', 'manager', 'user'][internalRoleIndex];

    const routesObject = {
      admin: {
        dashboard: 'dashboard',
        collectiontemplates: 'collectiontemplates',
        feedback: 'feedback',
        leaderboard: 'leaderboard',
        collectionresponses: 'collectionresponses',
        adminlmsscorm: 'scorm'
      },
      manager: {
        dashboard: 'dashboard',
        collectiontemplates: 'collectiontemplates',
        feedback: 'feedback',
        leaderboard: 'leaderboard',
        collectionresponses: 'collectionresponses',
        'my-leaderboard': 'my-leaderboard'
      },
      user: {
        dashboard: 'dashboard',
        feedback: 'feedback',
        leaderboard: 'leaderboard'
      }
    };

    return `company/${this.companyId}/lc/${verb}/${routesObject[verb][routingModule]}`;
  }

  get isLearningCenterActive(): boolean {

    const modules = [
      'adminlmsdashboard',
      'adminlmsviewtemplate',
      'adminlmsedittemplate',
    ];

    const otherModules = [
      'userlmsdashboard',
      'userlmsviewtemplate'
    ];
    const managerTemplateModules = [
      'managerlmsviewtemplate',
      'managerlmsedittemplate',
    ]
    if (this.getUserRoleIndex !== 2) {
      modules.push(...otherModules);
      modules.push(...managerTemplateModules);
    }

    return modules.includes(this.activeModule);
  }

  /**
   * To check if manager is assigned to salesmanager or user
   */
  userHasCoachingRights(): boolean {
    if (this.loggedInUserRole === profileRoles.salesManager) {
      return this.vPlaybookManagerId ? true : this.hasReps;
    }
    if (this.loggedInUserRole === profileRoles.user) {
      return !!this.vPlaybookManagerId;
    }
    return true;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.fetchCategoriesSub) {
      this.fetchCategoriesSub.unsubscribe();
    }
    if (this.pendingScoreSub) {
      this.pendingScoreSub.unsubscribe();
    }
    if (this.showDownloadSub) {
      this.showDownloadSub.unsubscribe();
    }
    if (this.feedbackChangeSub) {
      this.feedbackChangeSub.unsubscribe();
    }
    if (this.playbookBrandingSub) {
      this.playbookBrandingSub.unsubscribe();
    }
  }
}
